module.exports = __webpack_public_path__ + "public/SiteIcons/whyhostDownArrow.svg?45055f58";